//Models
PJQ.models.dailyReports.CommunicationLog = PJQ.models.BaseModel.extend({
	idAttribute: 'id',
	notifyName: 'Communication Log',
	endpoint: function () {
		let params = null;
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'dailyReports',
				value: this.get('dailyReportId')
			},
			{
				endpoint: 'communicationlogs',
				value: this.id
			}
		], params);
	},
	afterInit: function(){

	},
	parse: function (model) {
		if(model != null){
			if (model.contact) {
				this.contact = new PJQ.models.projectContacts.ProjectContact(model.contact);
			}
			else{
				this.contact = null;
			}

			this.attachments = new PJQ.collections.dailyReports.CommunicationLogAttachments(model.attachments);
			this.attachments.on('update', _.bind(function(){
				this.isDirty = true;
			}, this));
		}
		return model;
	},
	beforeSave: function () {
		this.set('contact', this.contact);
		this.set('attachments', this.attachments.getChangedModels());
	}
});

PJQ.models.dailyReports.CommunicationLogAttachment = PJQ.models.files.File.extend({
	idAttribute: 'attachmentId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'communicationlogs',
				value: this.get('logId')
			},
			{
				endpoint: 'attachments',
				value: this.id
			}
		]);
	}
});

//Collections
PJQ.collections.dailyReports.CommunicationLogs = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.dailyReports.CommunicationLog
});

PJQ.collections.dailyReports.CommunicationLogAttachments = PJQ.collections.dailyReports.Attachments.extend({
	model: PJQ.models.dailyReports.CommunicationLogAttachment
});